import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonIcon,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { documentTextOutline, walletOutline } from "ionicons/icons";
import React, { useState } from "react";

const justify = { textAlign: "justify" };

const Terms = ({ onDismiss }) => {
  const [state, setState] = useState({
    segmentValue: "tos",
  });
  return (
    <div className={"privacy-terms-policy"} style={{ height: "100%" }}>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            {!onDismiss && <IonBackButton text="" />}
          </IonButtons>
          <IonTitle>Terms of Service</IonTitle>
          {onDismiss && (
            <IonButtons slot="end">
              <IonButton fill="clear" onClick={onDismiss}>
                Close
              </IonButton>
            </IonButtons>
          )}
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard style={{ boxShadow: "none" }}>
          <IonSegment
            className="ionsegmentProfile "
            mode="md"
            onIonChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                segmentValue: e.detail.value,
              }))
            }
            value={state.segmentValue}
          >
            <IonSegmentButton className="ion-segment-buttonProfile" value="tos">
              <IonIcon icon={documentTextOutline} />
            </IonSegmentButton>
            <IonSegmentButton
              className="ion-segment-buttonProfile"
              value="rewards"
            >
              <IonIcon icon={walletOutline} />
            </IonSegmentButton>
          </IonSegment>
          {state.segmentValue === "tos" && (
            <>
              <IonCardHeader>
                <IonCardTitle>Terms of Service</IonCardTitle>
                <IonCardSubtitle>Last Updated: June 3, 2021</IonCardSubtitle>
              </IonCardHeader>
              <IonCardContent style={justify}>
                <br />
                <p>
                  Please read these Terms of Service (this “Agreement”)
                  carefully.
                </p>

                <br />
                <p>
                  This Agreement is between you and Oshi, LLC (“Oshi”, “we”, or
                  “us”) concerning your use of (including any access to) any of
                  our website, mobile applications, and other related platforms
                  (collectively, the “Oshi Platform”). When you access or use
                  our Oshi Platform, you acknowledge that you have read this
                  Agreement, understand the contents of this Agreement, and
                  agree to the terms of this Agreement.
                </p>
                <br />
                <p>
                  This Agreement hereby incorporates by this reference any
                  additional terms, conditions, and policies posted by Oshi
                  through domains accessible from the Oshi Platform, sent to you
                  via email, or otherwise made available to you by Oshi,
                  including Oshi’s Privacy Policy located at
                  https://Oshi.com/privacy and Oshi’s Terms of Rewards. Your use
                  of the Oshi Platform is governed by this Agreement regardless
                  of how you access the Oshi Platform, including through the
                  Internet, through Wireless Access Protocol (commonly referred
                  to as “WAP”), through a mobile network, or otherwise.
                </p>
                <br />
                <p>
                  BY USING OUR OSHI PLATFORM, YOU AFFIRM THAT YOU ARE OF LEGAL
                  AGE TO ENTER INTO THIS AGREEMENT. IF YOU ARE USING THE OSHI
                  PLATFORM ON BEHALF OF A COMPANY OR OTHER ORGANIZATION, THEN
                  YOU ARE ENTERING INTO THIS AGREEMENT ON BEHALF OF YOURSELF AND
                  SUCH ORGANIZATION, AND YOU HEREBY REPRESENT AND WARRANT TO US
                  THAT YOU HAVE THE LEGAL AUTHORITY TO BIND SUCH ORGANIZATION TO
                  THIS AGREEMENT. IF YOU DO NOT HAVE THE LEGAL AUTHORITY TO BIND
                  SUCH ORGANIZATION TO THIS AGREEMENT, YOU HEREBY INDEMNIFY AND
                  RELEASE OSHI FROM ANY AND ALL LIABILITY ARISING FROM YOUR USE
                  OF OUR OSHI PLATFORM.
                </p>

                <br />
                <p>
                  THIS AGREEMENT CONTAINS{" "}
                  <strong>A MANDATORY ARBITRATION PROVISION</strong>
                  THAT, AS FURTHER SET FORTH IN SECTION 12 BELOW, REQUIRES THE
                  USE OF ARBITRATION ON AN INDIVIDUAL BASIS TO RESOLVE DISPUTES,
                  RATHER THAN JURY TRIALS OR ANY OTHER COURT PROCEEDINGS, OR
                  CLASS ACTIONS OF ANY KIND.
                </p>
                <br />
                <p>
                  <strong>1. Changes to this Agreement</strong>
                </p>
                <br />
                <p>
                  We may change this Agreement by notifying you of such changes
                  by any reasonable means, including by posting a revised
                  Agreement on our Oshi Platform. Any such changes will become
                  effective on the “Last Updated” date indicated above and such
                  changes will not apply to any dispute between you and us
                  arising prior to such date on which the revised Agreement
                  incorporating such changes became effective, or otherwise
                  notified you of such changes.
                </p>
                <br />
                <p>
                  Your use of the Oshi Platform following any changes to this
                  Agreement will constitute your acceptance of such changes. The
                  “Last Updated” legend above indicates when this Agreement was
                  last changed. We may, at any time and without liability,
                  modify or discontinue all or part of the Oshi Platform
                  (including access via any third-party links); charge, modify,
                  or waive any fees required to use the Oshi Platform; or offer
                  opportunities to some or all users.
                </p>
                <br />
                <p>
                  <strong>2. Information You Submit to Us</strong>
                </p>
                <br />
                <p>
                  Your submission of information through the Oshi Platform is
                  governed by Oshi’s Privacy Policy, located at
                  https://Oshi.com/privacy (the “Privacy Policy”). You represent
                  and warrant that any information you provide in connection
                  with the Oshi Platform is and will remain accurate and
                  complete, and that you will maintain and update such
                  information as needed.
                </p>
                <br />
                <p>
                  <strong>3. Jurisdictional Issues</strong>
                </p>
                <br />
                <p>
                  The Oshi Platform is controlled or operated (or both) from the
                  United States and is not intended to subject Oshi to any
                  non-U.S. jurisdiction or law. The Oshi Platform may not be
                  appropriate or available for use in any non-U.S. jurisdiction.
                  Any use of the Oshi Platform is at your own risk, and you must
                  comply with all applicable laws, rules, and regulations in
                  doing so. We may limit the Oshi Platform’s availability at any
                  time, in whole or in part, to any person, geographic area, or
                  jurisdiction that we choose.
                </p>
                <br />
                <p>
                  <strong>4. Services</strong>
                </p>
                <br />
                <p>
                  The Oshi Platform may make available vouchers, promotions,
                  coupons, discounts, or other related offers (collectively,
                  “Merchant Listings”) for services, goods, or products provided
                  by third parties (“Merchants”) to individuals seeking such
                  Merchant Listings (“Purchasers”), as well as references and
                  links to Merchant Listings (making such Merchant Listings
                  available on the Oshi Platform, hereinafter, the “Services”).
                  The Merchants and Purchasers may be referred to individually
                  as a “User” and collectively herein as “Users.” The
                  availability through the Oshi Platform of any listing,
                  description, or image of Merchant Listing does not imply our
                  endorsement of such Merchant Listing or affiliation with the
                  provider of such Merchant Listing. We make no representations
                  as to the completeness, accuracy, or timeliness of such
                  listings, descriptions, or images (including any features,
                  specifications, and prices contained therein). Such
                  information and the availability of any Merchant Listing
                  (including the validity of any coupon or discount) is subject
                  to change at any time without notice. Certain weights,
                  measures, and similar descriptions are approximate and are for
                  convenience only. It is your responsibility to ascertain and
                  obey all applicable local, state, federal, and foreign laws
                  (including minimum age requirements) regarding the possession,
                  use, and sale of any Merchant Listing.
                </p>
                <br />
                <p>
                  Oshi offers Users the opportunity to transact Merchant
                  Listings on the Oshi Platform. The Oshi Platform offers
                  Merchants the ability to create a Merchant Listing, whereby a
                  Merchant may describe a product or service offered in the
                  Merchant Listings to be provided by the Merchant, the
                  Merchant’s location, and other information deemed pertinent by
                  the Merchant regarding its Merchant Listing and/or
                  product/service offerings. All connections facilitated by Oshi
                  involve Merchants advertising to Purchasers its own goods and
                  services and Merchant Listings provided solely by Merchants.
                  All details concerning a contract between Purchaser and
                  Merchant including, but not limited to, the type of Merchant
                  Listing, how the Merchant Listing is performed, or the
                  location at which the Merchant Listing is to be performed are
                  determined solely by Purchaser and Merchant. Users hereby
                  agree that all Merchant Listings transacted between Users are
                  undertaken at their own risk and discretion. Users hereby
                  acknowledges that Oshi does not conduct background checks on
                  Users or make any attempt to verify the information provided
                  by Users to Oshi. Merchant hereby acknowledges that by
                  agreeing to provide Merchant Listings to a Purchaser that
                  Merchant assumes all risks associated therewith and shall
                  perform inquiry into any Purchaser to Merchant’s satisfaction.
                  Merchant hereby acknowledges that it is Merchant’s
                  responsibility to put in place all safeguards necessary to
                  protect Merchant in Merchant’s interactions with Purchasers.
                  Users hereby acknowledge and agree that Oshi is not
                  responsible for and makes no representation regarding the
                  licensure, accreditation, or registration of any Merchant or
                  Merchant Listings provided, or the accuracy of information
                  presented on Merchant Listings or related to any Merchant.
                  Notwithstanding anything herein, Oshi reserves the right to
                  conduct background checks of any User using any third-party
                  background check services. Merchant background checks may
                  include, but are not limited to, verifying a User’s identity
                  and checking a User’s comprehensive criminal background. Oshi
                  may also interview certain of Merchant’s Purchasers from time
                  to time. Oshi hereby reserves the right to terminate a User’s
                  access to the Oshi Platform based on any information arising
                  from such a background check or interview with another User.
                </p>
                <br />
                <p>
                  NEITHER OSHI NOR ITS AFFILIATES OR LICENSORS IS RESPONSIBLE
                  FOR THE CONDUCT, WHETHER ON THE OSHI PLATFORM, ONLINE, OR
                  OFFLINE, OF ANY MERCHANT OR PURCHASER AND YOU HEREBY RELEASE
                  OSHI AND ITS AFFILIATES OR LICENSORS FROM ANY LIABILITY
                  RELATED THERETO OR ARISING THEREFROM. OSHI AND ITS AFFILIATES
                  AND LICENSORS SHALL NOT BE LIABLE FOR ANY CLAIM, INJURY,
                  DISPUTE, OR DAMAGE ARISING IN CONNECTION WITH OR RELATED TO
                  YOUR USE OF THE MERCHANT LISTINGS.
                </p>

                <br />
                <p>
                  Users hereby acknowledge and agree that Oshi is simply a
                  platform to facilitate connections among Users. Users hereby
                  acknowledge and agree that the Merchant Listings are performed
                  pursuant to an seller/buyer relationship and/or independent
                  contractor relationship solely between Users, and Oshi does
                  not have any control over the quality, suitability, training
                  of Merchants, reliability, scheduling, durability, legality,
                  performance, failure to provide, or any other aspect
                  whatsoever of any Merchant Listings provided by Merchants to
                  Purchasers. Oshi is not responsible for any act or omission or
                  otherwise of any Merchant or Purchaser. Oshi makes no
                  representations or warranties whatsoever with respect to any
                  Merchant Listings offered or provided by Merchants or any
                  inquiry by Purchasers regarding the Merchant Listings,
                  regardless of whether such Merchant/Purchaser interaction
                  occurs in public, in private, or offline.
                </p>
                <br />
                <p>
                  <strong>4.1 Fees.</strong>
                  <br />
                  Oshi collects a fee when a Merchant Listing is purchased by a
                  Purchaser (the “Fee”). The Fee and accompanying terms are set
                  forth in this Agreement, on the Oshi Platform, and/or accepted
                  and executed as one or more separate agreements by and between
                  you and Oshi.
                </p>
                <br />
                <p>
                  <strong>4.2 Payment.</strong>
                  <br />
                  If you wish to access the Oshi Platform and participate in the
                  purchasing and/or offering of Merchant Listings, you may be
                  asked to supply certain relevant information, such as your
                  credit card number and its expiration date, your billing
                  address, and your shipping information. YOU HEREBY REPRESENT
                  AND WARRANT THAT YOU HAVE THE RIGHT TO USE ANY CREDIT CARD
                  THAT YOU SUBMIT IN CONNECTION WITH A SUBSCRIPTION. By
                  submitting such information, you grant to us the right to
                  provide such information to third parties for purposes of
                  facilitating Merchant Listing transactions. Verification of
                  information may be required prior to the acknowledgment or
                  completion of any transaction. You agree to pay all charges
                  incurred by you or on your behalf through the Oshi Platform,
                  at the prices in effect when such charges are incurred,
                  including all shipping and handling charges, if any. In
                  addition, you are responsible for any taxes applicable to your
                  transaction. While it is our practice to confirm orders by
                  email, the receipt of an email order confirmation does not
                  constitute our acceptance of an order or our confirmation of
                  an offer to sell a product or Merchant Listing. Unless
                  otherwise stated, the Fee will be withheld at the time of the
                  transaction. All balances and all Fees, charges, and payments
                  collected or paid in relation to Merchant Listings may be
                  denominated in US dollars or Bitcoin.
                </p>
                <br />
                <p>
                  <strong>4.3 Payment by Purchaser to Merchant.</strong>
                  <br />
                  In the event Merchant has clearly posted return policy, refund
                  policy, Merchant Listing expiration, etc. (collectively,
                  “Return Policy”) on the Merchant Listing, a Merchant may
                  require a Purchaser to abide by such stated Return Policy.
                  Merchants shall resolve any such conflict regarding to the
                  satisfaction of both Purchaser and Oshi. Users hereby
                  acknowledge that (1) Oshi takes efforts it considers
                  reasonable to ensure the secure transmission of your payment
                  information to third parties who process payments, (2) Oshi
                  shall not be responsible for any errors associated with the
                  processing of payment information by third parties, (3) Oshi
                  shall not be responsible for any charges or fees assessed by
                  third parties, and (4) Oshi shall not be responsible for any
                  errors resulting from the negligence of a third party
                  processing payment information, the improper transmission of
                  payment information or erroneous payment information by a
                  third party or Merchant or Purchaser. Merchants hereby
                  acknowledge and agree that if such Merchant enters and/or
                  saves a Purchaser’s credit card or payment information to
                  Purchaser’s account, that Merchant has the necessary
                  authorization from Purchaser to perform such act. As such,
                  Merchant hereby agrees to take full responsibility for
                  fulfilling the Purchaser’s preferences regarding Merchant’s
                  usage of Purchaser’s payment information and hereby agrees to
                  indemnify Oshi for any and all claims arising from or out of
                  Merchant’s usage of Purchaser’s payment information.
                </p>
                <br />
                <p>
                  <strong>5. Your Account with Us</strong>
                </p>
                <br />
                <p>
                  When you create an account with us (an “Account”), you will be
                  asked to provide certain information about yourself,
                  including, without limitation, your name, business name,
                  business address, billing address, business webservice,
                  licenses held, accreditations held, and other information
                  about you and your business. It is your sole responsibility to
                  maintain the security of your Account. You are responsible for
                  any activity of any person you allow to access your Account.
                  Any activity by your Account is your sole responsibility and
                  Oshi or its affiliates or licensors is not liable for any
                  losses, damages, liabilities, charges, incurred, suffered, or
                  arising from or out of your failure to maintain your Account’s
                  security. You agree to follow all rules and applicable laws in
                  connection with the use of your Account. In the event your
                  Account security is compromised, you hereby agree to notify us
                  immediately.
                </p>
                <br />
                <p>
                  In connection with creating your Account, you will be asked to
                  verify that you are a citizen of the United States of America,
                  a legal resident of the United States of America, or a
                  business entity validly formed in a jurisdiction in the United
                  States of America and in good standing in such jurisdiction of
                  formation. You will also be asked to create an “Account Name”
                  (herein so called). This Account Name must be unique and will
                  serve various functions for your Account. Your Account Name
                  may not contain offensive words, phrases, or connotations.
                  Please be aware that your Account Name may appear on all
                  Purchaser and Merchant credit card statements and payment
                  records. Upon creating an Account selecting an Account Name,
                  you will be granted a non-transferrable license to use our
                  Oshi Platform, subject to this Agreement and other policies
                  listed on our Oshi Platform or sent to you via email or mail.
                  Accounts and Merchant Listings are only intended for use in
                  the United States of America. Merchant hereby acknowledges and
                  agrees that not it shall not export the Merchant Listings
                  directly or indirectly, and you hereby acknowledge that the
                  Merchant Listings may be subject to export restrictions
                  imposed by US law, including US Export Administration
                  Regulations (15 C.F.R. Chapter VII), and that any
                  international use must comply with international laws.
                  Merchant hereby acknowledges and agrees that all information
                  provided by Merchant to us is accurate, complete, and true.
                  Merchant acknowledges and agrees that Merchant has created the
                  Account on Merchant’s behalf, or, in the case of a business
                  entity, that Merchant has the necessary authority to create an
                  Account and on behalf of said business. Merchant hereby
                  acknowledges and agrees that if Merchant is a business that
                  all its employees, independent contractors, and/or licensors
                  have and maintain the licenses and/or accreditations necessary
                  to provide the Merchant Listings. Merchant hereby consents to
                  Oshi verifying any information provided to Oshi by Merchant.
                  In the event such information of Merchant changes, Merchant
                  agrees to promptly provide such information to us.
                </p>
                <br />
                <p>
                  By creating an Account as a Merchant, you hereby agree that
                  you shall not accept payments from or in connection with the
                  following businesses or business activities: (1) any illegal
                  activity or goods, (2) buyers or membership clubs, including
                  dues associated with such clubs, (3) credit counseling or
                  credit repair agencies, (4) credit protection or identity
                  theft protection Merchant Listings, (5) direct marketing or
                  subscription offers or Merchant Listings, (6) infomercial
                  sales, (7) internet/mail order/telephone order pharmacies or
                  pharmacy referral Merchant Listings (where fulfillment of
                  medication is performed with an internet or telephone
                  consultation, absent a physical visit with a physician
                  including re-importation of pharmaceuticals from foreign
                  countries), (8) unauthorized multi-level marketing businesses,
                  (9) inbound or outbound telemarketers, (10) prepaid phone
                  cards or phone Merchant Listings, (11) rebate based
                  businesses, (12) up-sell merchants, (13) bill payment Merchant
                  Listings, (14) betting, including lottery tickets, casino
                  gaming chips, off-track betting, and wagers at races, (15)
                  manual or automated cash disbursements, (16) prepaid cards,
                  checks, or other financial merchandise or Merchant Listings,
                  (17) sales of money-orders or foreign currency, (18) wire
                  transfer money orders, (19) high-risk products and Merchant
                  Listings, including telemarketing sales, (20) Merchant Listing
                  station merchants, (21) automated fuel dispensers, (22) adult
                  entertainment oriented products or Merchant Listings (in any
                  medium, including internet, telephone, or printed material),
                  (23) sales of (i) firearms, firearm parts or hardware, and
                  ammunition; or (ii) weapons and other devices designed to
                  cause physical injury, (24) internet/mail order/telephone
                  order cigarette or tobacco sales, (25) drug paraphernalia,
                  (26) occult materials, (27) hate or harmful products, (28)
                  escort Merchant Listings, or (29) bankruptcy attorneys or
                  collection agencies engaged in the collection of debt.
                </p>
                <br />
                <p>
                  Oshi reserves the right to ask Merchant follow up questions
                  regarding information provided by Merchant and to periodically
                  request additional information from Merchant. Merchant agrees
                  to promptly provide responses to such requests by Oshi. We
                  reserve the right to suspend Merchant’s Account during
                  verification of or inquiry into any information provided to us
                  by Merchant. Oshi may suspend or terminate any Account it
                  determines contains false, misleading, inaccurate information,
                  or an Account Name that, in the sole discretion of Oshi, is
                  offensive, misleading, or infringing any intellectual property
                  of another party, or if Merchant has violated this Agreement
                  or any of Oshi’s policies, poses an unacceptable risk to Oshi,
                  in Oshi’s sole discretion, or has engaged in illegal or
                  fraudulent conduct. Oshi does not verify that Account Names do
                  not infringe the trademark or intellectual property rights of
                  any other Merchant, Purchaser, or other party. In the event a
                  Merchant’s Account is terminated or suspended due to Merchant
                  providing false, misleading, or inaccurate information to
                  Oshi, or due to Merchant’s Account Name, in Oshi’s sole
                  discretion, being offensive, misleading, or infringing the
                  intellectual property rights of another party, Merchant will
                  not be refunded any part of the Fee and Oshi may restrict
                  access to the funds in Merchant’s Account. If your Account is
                  terminated or suspended for any reason or no reason, you agree
                  that you will continue to be bound by this Agreement, to
                  immediately stop using the Oshi Platform, that any license(s)
                  granted to you by us shall terminate immediately, that we
                  reserve the right to hide or delete any or all of your
                  information and account data stored on our servers, and that
                  we have no obligation to hide or delete any or all of your
                  information and account data stored on our servers. We shall
                  not be liable to you or any third party for termination or
                  suspension of access to the Merchant Listings or your Account
                  or for deletion or hiding of your information or account data.
                  You hereby agree and acknowledge that to comply with
                  investigations and applicable law, we may retain and use your
                  information and account data
                </p>
                <br />
                <p>
                  In the event Merchant desires to correct the information
                  provided to us and create a new Account, Merchant must contact
                  Oshi in writing at satoshi@oshi.tech. Oshi shall have the sole
                  discretion to allow Merchant to create a new Account or not.
                </p>
                <br />
                <p>
                  You may terminate your Account with us at any time. When you
                  terminate your Account, any transactions your Account has
                  pending will be cancelled. Any termination of your Account
                  does not relieve you of any obligations to pay any fees or
                  costs accrued prior to the termination and any other amounts
                  owed by you to us as provided in this Agreement or other
                  agreement with us. We shall not be liable to you for
                  compensation, reimbursement, or damages in connection with
                  your use of the Services or your Account, or in connection
                  with any termination or suspension of the Services or your
                  Account.
                </p>
                <br />
                <p>
                  When you provide your wireless number and/or email address to
                  us, you confirm and agree to receive communications from us
                  and that you desire for Oshi to send you SMS messages and/or
                  email messages regarding developments, marketing, upcoming
                  appointment reservations, other reminders, and other
                  information regarding the Services and/or your Account. By
                  providing us with your wireless number and/or email address,
                  you represent and warrant that you have the authority to
                  provide us with such wireless number and/or email address and
                  that the owner of such number and/or email address has
                  consented to receiving communications from us. We may also
                  send SMS messages to you regarding upcoming appointments and
                  other reminders using a short code text messaging service. You
                  agree to indemnify and hold Oshi harmless from and against any
                  and all claims, liabilities, damages (actual and
                  consequential), losses and expenses (including attorneys’
                  fees) arising from or in any way related to your breach of the
                  foregoing. You understand that you are not required to provide
                  this consent as a condition of using our Services and may opt
                  out of receiving autodialed text messages from Oshi at any
                  time.
                </p>
                <br />
                <p>
                  Please remember that message and data rates may apply for any
                  messages we send to you and you send to us. You may receive
                  messages including but not limited to appointment
                  confirmations, appointment requests, appointment reminders,
                  and payment receipts and/or tips. You should contact your
                  wireless provider if you have any questions about your data
                  plan or text plan. For all questions about the service
                  provided by this messaging service, please contact us at
                  satoshi@oshi.tech
                </p>
                <br />
                <p>
                  <strong>6. Payment Processing</strong>
                </p>
                <br />
                <p>
                  Oshi uses a third-party, OpenNode, Inc. (“OpenNode”), to
                  facilitate the Services and transactions of Merchant Listings
                  between Users. By enrolling in or using any Oshi Platform, you
                  acknowledge that you have read and understand OpenNode’s Terms
                  and Conditions (found at
                  https://www.opennode.com/terms-and-conditions/) and OpenNode’s
                  Privacy Policy (found at
                  https://www.opennode.com/privacy-policy/) and further agree to
                  be bound by all terms found therein.
                </p>
                <br />
                <p>
                  <strong>7. Rules of Conduct</strong>
                </p>
                <br />
                <p>
                  In connection with the Merchant Listings and your Account, you
                  agree not to:
                </p>
                <br />
                <p>
                  (a) Post, transmit or otherwise make available through or in
                  connection with the Merchant Listings or your Account any
                  materials that are or may be: (a) threatening, harassing,
                  degrading, hateful or intimidating, or otherwise fail to
                  respect the rights and dignity of others; (b) defamatory,
                  libelous, fraudulent or otherwise tortious; (c) obscene,
                  indecent, pornographic or otherwise objectionable; or (d)
                  protected by copyright, trademark, trade secret, right of
                  publicity or privacy or any other proprietary right, without
                  the express prior written consent of the applicable owner.
                </p>
                <br />
                <p>
                  (b) Post, transmit or otherwise make available through or in
                  connection with the Merchant Listings or your Account any
                  virus, worm, Trojan horse, Easter egg, time bomb, spyware or
                  other computer code, file or program that is potentially
                  harmful or invasive or intended to damage or hijack the
                  operation of, or to monitor the use of, any hardware, software
                  or equipment.
                </p>
                <br />
                <p>
                  (c) Use your Account or the Oshi Platform for any purpose that
                  is fraudulent or otherwise tortious or unlawful.
                </p>
                <br />
                <p>
                  (d) Harvest or collect information about Users of the Services
                  or the Oshi Platform.
                </p>
                <br />
                <p>
                  (e) Interfere with or disrupt the operation of the Services,
                  your Account, or the Oshi Platform or the servers or networks
                  used to make such available, including by hacking or defacing
                  any portion of the Merchant Listings, your Account, or the
                  Oshi Platform; or violate any requirement, procedure, or
                  policy of such servers or networks.
                </p>
                <br />
                <p>
                  (f) Restrict or inhibit any other person from using the
                  Services, their Account, or the Oshi Platform.
                </p>
                <br />
                <p>
                  (g) Reproduce, modify, adapt, translate, create derivative
                  works of, sell, rent, lease, loan, timeshare, distribute or
                  otherwise exploit any portion of (or any use of) the Oshi
                  Platform except as expressly authorized herein, without Oshi’s
                  express prior written consent.
                </p>
                <br />
                <p>
                  (h) Reverse engineer, decompile, or disassemble any portion of
                  the Oshi Platform, except where such restriction is expressly
                  prohibited by applicable law.
                </p>
                <br />
                <p>
                  (i) Remove any copyright, trademark, or other proprietary
                  rights notice from your Account, the Merchant Listings, or the
                  Oshi Platform.
                </p>
                <br />
                <p>
                  (j) Frame or mirror any portion of the Merchant Listings, your
                  Account, the Oshi Platform, or otherwise incorporate any
                  portion of the Merchant Listings, your Account, or the Oshi
                  Platform into any product or Merchant Listing, without Oshi’s
                  express prior written consent.
                </p>
                <br />
                <p>
                  (k) Systematically download and store content of the Merchant
                  Listings, your Account, or the Oshi Platform.
                </p>
                <br />
                <p>
                  (l) Use any robot, spider, Oshi Platform search/retrieval
                  application or other manual or automatic device to retrieve,
                  index, “scrape,” “data mine” or otherwise gather content from
                  the Oshi Platform, or reproduce or circumvent the navigational
                  structure or presentation of the Oshi Platform, without Oshi’s
                  express prior written consent. Notwithstanding the foregoing,
                  and subject to compliance with any instructions herein or
                  posted to the Oshi Platforms’ root directories, Oshi grants to
                  the operators of public search engines permission to use
                  spiders to copy materials from the Oshi Platform for the sole
                  purpose of (and solely to the extent necessary for) creating
                  publicly available, searchable indices of such materials, but
                  not caches or archives of such materials. Oshi reserves the
                  right to revoke such permission either generally or in
                  specific cases, at any time and without notice.
                </p>
                <br />
                <p>
                  (m) Post any fictitious content of any form, including,
                  without limitation, events or offers or other information, to
                  the Oshi Platform that is false or may compromise or otherwise
                  harm Oshi, the Oshi Platform, or our affiliates.
                </p>

                <br />
                <p>
                  You are responsible for obtaining, maintaining, and paying for
                  all hardware and all telecommunications and other services
                  needed to use the Oshi Platform, the Merchant Listings, and
                  your Account.
                </p>
                <br />
                <p>
                  <strong>8. Intellectual Property Rights</strong>
                </p>
                <br />
                <p>
                  Subject to your compliance with this Agreement, and solely for
                  so long as you are permitted by Oshi to use your Account, you
                  may use your Account. The Oshi Platform is licensed (not sold)
                  to end users. Subject to your compliance with this Agreement,
                  and solely for so long as you are permitted by Oshi to use
                  your Account and/or the Oshi Platform, we hereby permit you,
                  on a limited, non-exclusive, revocable, non-transferable,
                  non-sublicensable basis, to use your Account and install and
                  use the Oshi Platform on a mobile device that you own or
                  control.
                </p>
                <br />
                <p>
                  We and our suppliers own the Oshi Platform, which are
                  protected by proprietary rights and laws. If you fail to
                  comply with any of the terms or conditions of this Agreement,
                  you must immediately cease using the Oshi Platform and remove
                  (that is, uninstall and delete) it from your mobile device.
                  All trade names, trademarks, Merchant Listing marks, and logos
                  on the Oshi Platform not owned by us are the property of their
                  respective owners. You may not use our trade names,
                  trademarks, Merchant Listing marks, or logos in connection
                  with any product or Merchant Listing that is not ours, or in
                  any manner that is likely to cause confusion. Nothing
                  contained on the Oshi Platform should be construed as granting
                  any right to use any trade names, trademarks, Merchant Listing
                  marks, or logos without the express prior written consent of
                  the owner.
                </p>
                <br />
                <p>
                  Certain functionality of the Oshi Platform may make available
                  access to materials made available by third parties (“Third
                  Party Materials”), or allow for the routing or transmission of
                  such Third Party Materials, including via links. By using such
                  functionality, you are directing us to access, route and
                  transmit to you the applicable Third Party Materials. We
                  neither control nor endorse, nor are we responsible for, any
                  Third Party Materials, including the accuracy, integrity,
                  quality, legality, usefulness, or safety of Third Party
                  Materials, or any intellectual property rights therein.
                  Certain Third Party Materials may, among other things, be
                  inaccurate, misleading, or deceptive. Nothing in this
                  Agreement shall be deemed to be a representation or warranty
                  by Oshi with respect to any Third Party Materials. We have no
                  obligation to monitor Third Party Materials, and we may block
                  or disable access to any Third Party Materials (in whole or
                  part) through the Oshi Platform at any time. In addition, the
                  availability of any Third Party Materials through the Oshi
                  Platform does not imply our endorsement of, or our affiliation
                  with, any provider of such Third Party Materials, nor does
                  such availability create any legal relationship between you
                  and any such provider. YOU ARE NEVER ALLOWED TO COPY OSHI
                  PLATFORM CONTENT MANUALLY OR ELECTRONICALLY – THIS PROHIBITION
                  INCLUDES, WITHOUT LIMITATION, IN THE EVENT THAT A USER OF THE
                  OSHI PLATFORM GRANTS YOU PERMISSION TO ACCESS THEIR ACCOUNT.
                </p>
                <br />
                <p>
                  YOUR USE OF THIRD PARTY MATERIALS IS AT YOUR OWN RISK AND IS
                  SUBJECT TO ANY ADDITIONAL TERMS, CONDITIONS, AND POLICIES
                  APPLICABLE TO SUCH THIRD PARTY MATERIALS (SUCH AS TERMS OF
                  MERCHANT LISTING OR PRIVACY POLICIES OF THE PROVIDERS OF SUCH
                  THIRD PARTY MATERIALS).
                </p>
                <br />
                <p>
                  <strong>9. Disclaimer of Warranties</strong>
                </p>
                <br />
                <p>
                  TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW: (A) THE
                  OSHI PLATFORM AND ANY MERCHANT LISTINGS AND THIRD PARTY
                  MATERIALS ARE MADE AVAILABLE TO YOU “AS IS” WITHOUT ANY
                  WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED OR STATUTORY:
                  AND (B) OSHI DISCLAIMS ALL WARRANTIES WITH RESPECT TO THE OSHI
                  PLATFORM AND ANY MERCHANT LISTINGS AND THIRD PARTY MATERIALS
                  TO THE FULLEST EXTENT PERMISSIBLE UNDER APPLICABLE LAW,
                  INCLUDING THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                  PARTICULAR PURPOSE, NON-INFRINGEMENT AND TITLE. THE PRODUCTS
                  ARE NOT DESIGNED FOR COMMERCIAL USE (SUCH AS USE IN HOTELS,
                  RESTAURANTS OR ANY OTHER PLACE WHERE THE PUBLIC MAY USE A
                  PRODUCT OUTSIDE OF A PRIVATE RESIDENTIAL SETTING), AND,
                  WITHOUT LIMITING ANY OTHER DISCLAIMER HEREIN, TO THE FULLEST
                  EXTENT PERMITTED UNDER APPLICABLE LAW, WE DISCLAIM ALL
                  LIABILITY FOR ANY DAMAGES ARISING FROM SUCH COMMERCIAL USE.
                  THIS SECTION 9 DOES NOT AFFECT ANY EXPRESS WARRANTIES THAT WE
                  MAY PROVIDE DIRECTLY TO YOU IN WRITING WITH RESPECT TO
                  MERCHANT LISTINGS OR YOUR ACCOUNT.
                </p>
                <br />
                <p>
                  ALL DISCLAIMERS OF ANY KIND (INCLUDING IN THIS SECTION AND
                  ELSEWHERE IN THIS AGREEMENT) ARE MADE FOR THE BENEFIT OF BOTH
                  OSHI AND ITS AFFILIATES AND THEIR RESPECTIVE SHAREHOLDERS,
                  DIRECTORS, OFFICERS, EMPLOYEES, AFFILIATES, AGENTS,
                  REPRESENTATIVES, LICENSORS, SUPPLIERS AND MERCHANT LISTING
                  PROVIDERS (COLLECTIVELY, THE “AFFILIATED ENTITIES”).
                </p>
                <br />
                <p>
                  While we try to maintain the timeliness, integrity and
                  security of the Oshi Platform, we do not guarantee that the
                  Oshi Platform are or will remain updated, complete, correct or
                  secure, or that access to the Oshi Platform will be
                  uninterrupted. The Oshi Platform may include inaccuracies,
                  errors, and materials that violate or conflict with this
                  Agreement. Additionally, third parties may make unauthorized
                  alterations to the Oshi Platform. If you become aware of any
                  such alteration, please contact us and provide a description
                  of such alteration and its location.
                </p>
                <br />
                <p>
                  <strong>10. Limitation of Liability</strong>
                </p>
                <br />
                <p>
                  TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW: OSHI
                  WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
                  CONSEQUENTIAL, SPECIAL, EXEMPLARY OR PUNITIVE DAMAGES OF ANY
                  KIND, UNDER ANY CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT
                  LIABILITY OR OTHER THEORY, INCLUDING DAMAGES FOR LOSS OF
                  PROFITS, USE OR DATA, LOSS OF OTHER INTANGIBLES, LOSS OF
                  SECURITY OF INFORMATION TRANSMITTED VIA THE OSHI PLATFORM
                  (INCLUDING UNAUTHORIZED INTERCEPTION BY THIRD PARTIES OF SUCH
                  INFORMATION), EVEN IF ADVISED IN ADVANCE OF THE POSSIBILITY OF
                  SUCH DAMAGES OR LOSSES. WITHOUT LIMITING THE FOREGOING, TO THE
                  FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW: (A) OSHI WILL
                  NOT BE LIABLE FOR DAMAGES OF ANY KIND RESULTING FROM YOUR USE
                  OF OR INABILITY TO USE THE OSHI PLATFORM OR FROM ANY PRODUCTS
                  OR THIRD PARTY MATERIALS: (B) YOUR SOLE AND EXCLUSIVE REMEDY
                  FOR DISSATISFACTION WITH THE OSHI PLATFORM OR ANY PRODUCTS OR
                  THIRD PARTY MATERIALS IS TO STOP USING THE OSHI PLATFORM: AND
                  (C) THE MAXIMUM AGGREGATE LIABILITY OF OSHI FOR ALL DAMAGES,
                  LOSSES AND CAUSES OF ACTION, WHETHER IN CONTRACT, TORT
                  (INCLUDING NEGLIGENCE) OR OTHERWISE, SHALL BE THE GREATER OF:
                  (1) THE TOTAL AMOUNT, IF ANY, PAID BY YOU TO OSHI TO USE THE
                  OSHI PLATFORM; AND (2) TEN U.S. DOLLARS ($10).
                </p>
                <br />
                <p>
                  ALL LIMITATIONS OF LIABILITY OF ANY KIND (INCLUDING IN THIS
                  SECTION AND ELSEWHERE IN THIS AGREEMENT) ARE MADE FOR THE
                  BENEFIT OF BOTH OSHI AND THE AFFILIATED ENTITIES.
                </p>
                <br />
                <p>
                  Applicable law in certain states may not allow for limitations
                  on certain implied warranties, or exclusions or limitations of
                  certain damages; solely to the extent that such law applies to
                  you, some or all of the above disclaimers, exclusions, or
                  limitations may not apply to you, and you may have certain
                  additional rights.
                </p>
                <br />
                <p>
                  <strong>11. Indemnity</strong>
                </p>
                <br />
                <p>
                  To the fullest extent permitted under applicable law, you
                  agree to defend, indemnify and hold harmless Oshi and the
                  Affiliated Entities from and against all claims, losses, costs
                  and expenses (including attorneys’ fees) arising out of (a)
                  your use of, or activities in connection with, any of the Oshi
                  Platform or your Account or the Merchant Listings; and (b) any
                  violation or alleged violation of this Agreement by you.
                </p>

                <br />
                <p>
                  <strong>
                    12. Governing Law and Mandatory Arbitration Provision
                  </strong>
                </p>
                <br />
                <p>
                  If a dispute, controversy or claim, of any kind and every kind
                  or type, whether based on contract, tort, statute,
                  regulations, or otherwise, arising out of, or connected with,
                  or relating in any way to this Agreement, or the relationship
                  of the parties, or the obligations of the parties, or the
                  scope of this arbitration agreement, of the operations carried
                  out under this Agreement, including without limitation, any
                  dispute as to the existence, validity, construction,
                  interpretation, negotiation, performance, non-performance,
                  breach, termination, scope, or enforceability of this
                  Agreement, or the breach thereof (any one of which
                  constituting the “Dispute”), and if the Dispute cannot be
                  settled through direct discussions (in the opinion of any
                  party), the parties agree to first endeavor to settle the
                  Dispute in an amicable manner by mediation under the then
                  current Commercial Mediation Rules of the American Arbitration
                  Association (“AAA”), before resorting to arbitration. If the
                  Dispute is not settled by mediation within thirty (30) days of
                  written request for mediation by any party to AAA, then and
                  thereafter any unresolved Dispute, including the arbitrability
                  of any unresolved Dispute, shall be settled by arbitration
                  administered by the American Arbitration Association (“AAA”)
                  in accordance with the then current AAA Commercial Arbitration
                  Rules with the award being final and binding. Judgment upon
                  the award rendered by the arbitrator may be entered in any
                  court having jurisdiction thereof. Any provisional remedy
                  which would be available from a court of law shall be
                  available from the arbitrator to the parties to this Agreement
                  pending arbitration.
                </p>
                <br />
                <p>
                  The Federal Arbitration Act shall govern all arbitration
                  proceedings under this Agreement. This Agreement shall in all
                  other respects be governed and interpreted by the laws of the
                  State of Texas, including its statutes of limitation but
                  excluding any conflicts or choice of law rule or principles
                  that might otherwise refer construction or interpretation of
                  this Agreement to the substantive law of another jurisdiction.
                  The arbitration shall be conducted in Fort Worth, Texas, by
                  one neutral arbitrator chosen by AAA according to its
                  Commercial Arbitration Rules. Neither party nor the arbitrator
                  may disclose the existence, content, or results of any
                  arbitration hereunder without the prior written consent of all
                  parties. All fees and expenses of the arbitration shall be
                  borne by the parties equally who shall make deposits as
                  requested by AAA of each party’s share of the deposits
                  requested. Failure or refusal by a party to pay its share of
                  the requested deposits shall constitute a waiver by the
                  non-paying party of its rights to be heard, present evidence,
                  cross-examine witnesses, and assert counterclaims in the
                  arbitration. Informing the arbitrator of a party’s failure to
                  pay its share of the requested deposits for the purpose of
                  implementing this waiver provision shall not be deemed to
                  affect the arbitrator’s impartiality, neutrality,
                  independence, or ability to proceed with the arbitration.
                  However, each party shall bear the expense of its own counsel,
                  experts, witnesses, and preparation and presentation of
                  proofs. The prevailing party, according to the arbitrator,
                  shall be entitled to an award of reasonable attorney’s fees
                  for the arbitration and for all appeals of the award,
                  arbitration fees and administrative expenses, and pre-award
                  and post-award interest at the prevailing Texas statutory
                  pre-judgment and post-judgment interest rates. This agreement
                  to arbitrate shall survive the termination or repudiation of
                  this Agreement.
                </p>
                <br />
                <p>
                  <strong>13. Parental Filtering</strong>
                </p>
                <br />
                <p>
                  None of the information on the Oshi Platform is intended for
                  the use of children under thirteen (13) years of age, and Oshi
                  does not knowingly register any person or accept information
                  from any person under thirteen (13) years of age.
                </p>
                <br />
                <p>
                  We hereby notify you that parental control protections (such
                  as computer hardware, software, or filtering Merchant
                  Listings) are commercially available that may assist you in
                  limiting access to material that may be harmful to minors.
                </p>
                <br />
                <p>
                  Information identifying current providers of such protections
                  is available from
                  https://en.wikipedia.org/wiki/Comparison_of_contentcontrol_software_and_providers.
                  Please note that Oshi does not endorse any of the products or
                  Merchant Listings listed on such Oshi Platform, nor can Oshi
                  confirm the completeness or accuracy of such information
                  presented on such Oshi Platform.
                </p>
                <br />
                <p>
                  <strong>
                    14. Modifications to the Services; Force Majeure
                  </strong>
                </p>
                <br />
                <p>
                  You acknowledge that Oshi, its affiliates, and/or licensors
                  reserve the right to edit, suspend, or terminate any part or
                  all of the Services at any time for any reason or for no
                  reason. While we use our reasonable best efforts to ensure the
                  Services and Oshi Platform function at all times, we are not
                  obligated to update or maintain the Services or the Oshi
                  Platform, and we are not obligated to ensure the Services
                  and/or Oshi Platform function properly on your personal
                  computer or device. You acknowledge that Oshi’s platform and
                  the Services may experience technical issues, including,
                  without limitation, interruptions of Services or errors, that
                  my affect your use of the Services. You acknowledge that we
                  may plan downtime for the Services and/or Oshi Platform. We
                  will use our reasonable best efforts to communicate planned
                  downtime to you at least eight (8) hours prior to the planned
                  downtime. We shall not be liable for any delay or failure to
                  perform any obligation under this Agreement or otherwise where
                  the delay or failure results from or arises out of any
                  circumstances beyond our control, including, without
                  limitation, acts of God, acts of government, epidemics,
                  pandemics, natural disaster, civil unrest, strikes or other
                  labor problems, any outbreak or escalation of hostilities or
                  declared or undeclared acts of war or terrorism, any Internet
                  services provider delays or failures, any event, change, fact,
                  condition, circumstance, or occurrence that, when considered
                  individually or in the aggregate together with all other
                  adverse events, changes, facts, conditions, circumstances, or
                  occurrences, has had or would be reasonably expected to have
                  an adverse effect on Oshi, including without limitation,
                  Oshi’s business, operations, results of operations,
                  properties, assets, or condition (financial or otherwise).
                </p>
                <br />
                <p>
                  <strong>15. Miscellaneous</strong>
                </p>
                <br />
                <p>
                  This Agreement does not, and shall not be construed to, create
                  any partnership, joint venture, employer-employee, agency, or
                  franchisor-franchisee relationship between you and Oshi. If
                  any provision of this Agreement is found to be unlawful, void
                  or for any reason unenforceable, that provision will be deemed
                  severable from this Agreement and will not affect the validity
                  and enforceability of any remaining provision. You may not
                  assign, transfer or sublicense any or all of your rights or
                  obligations under this Agreement without our express prior
                  written consent. We may assign, transfer or sublicense any or
                  all of our rights or obligations under this Agreement without
                  restriction. No waiver by either party of any breach or
                  default hereunder will be deemed to be a waiver of any
                  preceding or subsequent breach or default. Any heading,
                  caption or section title contained herein is for convenience
                  only, and in no way defines or explains any section or
                  provision. All terms defined in the singular shall have the
                  same meanings when used in the plural, where appropriate and
                  unless otherwise specified. Any use of the term “including” or
                  variations thereof in this Agreement shall be construed as if
                  followed by the phrase “without limitation”. This Agreement,
                  including any terms and conditions incorporated herein, is the
                  entire agreement between you and Oshi relating to the subject
                  matter hereof, and supersedes any and all prior or
                  contemporaneous written or oral agreements or understandings
                  between you and Oshi relating to such subject matter. Notices
                  to you (including notices of changes to this Agreement) may be
                  made via posting to the Oshi Platform or by email (including
                  in each case via links), or by regular mail. Without
                  limitation, a printed version of this Agreement and of any
                  notice given in electronic form shall be admissible in
                  judicial or administrative proceedings based upon or relating
                  to this Agreement to the same extent and subject to the same
                  conditions as other business documents and records originally
                  generated and maintained in printed form. Oshi will not be
                  responsible for any failure to fulfill any obligation due to
                  any cause beyond its control.
                </p>
                <br />
                <p>
                  <strong>16. Contact Us</strong>
                </p>
                <br />
                <p>
                  If you have a question or complaint regarding any of the
                  Services, please contact us by visiting https://www.oshi.tech.
                </p>
                <br />
                <p>
                  You may email us at:
                  <br />
                  <strong>satoshi@oshi.tech</strong>
                </p>
                <br />
                <p>You may also contact us by writing to:</p>
                <br />
                <p>
                  Oshi <br />
                  <strong>
                    Attn: Customer Merchant Listing <br />
                    245 Lazy Creek Dr <br />
                    Georgetown, TX 78628
                  </strong>
                </p>
                <br />
                <p>
                  You may contact us by phone by calling:{" "}
                  <strong>1-617-682-9767</strong>
                </p>
                <br />
                <p>
                  Please note that email communications will not necessarily be
                  secure; accordingly, you should not include credit card
                  information or other sensitive information in your email
                  correspondence with us. California residents may reach the
                  Complaint Assistance Unit of the Division of Consumer Merchant
                  Listings of the California Department of Consumer Affairs by
                  mail at 1625 North Market Blvd., Sacramento, CA 95834, or by
                  telephone at (916) 445-1254 or (800) 952-5210.
                </p>

                <br />
              </IonCardContent>
            </>
          )}

          {state.segmentValue === "rewards" && (
            <>
              <IonCardHeader>
                <IonCardTitle>Terms of Rewards</IonCardTitle>
                <IonCardSubtitle>Last Updated: June 3, 2021</IonCardSubtitle>
              </IonCardHeader>
              <IonCardContent style={justify}>
                <br />
                <p>
                  Oshi, LLC (“Oshi” or “we”) offers Rewards (defined below) for
                  certain purchases completed through its websites, mobile
                  applications, and other related platforms (collectively, the
                  “Oshi Platforms”). The Rewards and eligibility to receive the
                  Rewards are subject to these Terms of Rewards (“Agreement).
                  The Rewards can be denominated in bitcoin or other currency
                  (also referred to as “rewards,” “sats,” or “bitcoin”), on
                  Eligible Transactions (defined below). This Agreement
                  constitutes a legally binding agreement between each
                  individual who receives Rewards or otherwise uses any one of
                  the Oshi Platforms (“Member” or “you”).
                </p>
                <br />
                <p>
                  <strong>
                    Oshi reserves the right to change or modify this Agreement
                    at any time and in our sole discretion.
                  </strong>{" "}
                  If Oshi makes changes to this Agreement, we will provide
                  notice of such changes, by providing notice through the Oshi
                  Platforms, by e-mail and/or by updating this Agreement (as
                  indicated by the “Last Updated” date found at the top of this
                  Agreement) on the Oshi website (found at
                  https://Oshiapp.com/terms-of-rewards-program/) and/or on the
                  Oshi mobile application for iOS and Android. You agree to
                  receive app-based notifications through these means and your
                  continued use of the Oshi Platform(s) to earn Rewards will
                  indicate your acceptance of the revised Agreement. If you do
                  not agree to any amended Agreement, you must stop using the
                  Oshi Platform(s).
                </p>
                <br />
                <p>
                  By enrolling in or using any Oshi Platform, you acknowledge
                  that you have read and understood this Agreement and agree to
                  be bound by all of its terms.
                </p>
                <br />
                <p>
                  BY USING ANY OSHI PLATFORM, YOU AFFIRM THAT YOU ARE OF LEGAL
                  AGE TO ENTER INTO THIS AGREEMENT. IF YOU ARE USING AN OSHI
                  PLATFORM ON BEHALF OF A COMPANY OR OTHER ORGANIZATION, THEN
                  YOU ARE ENTERING INTO THIS AGREEMENT ON BEHALF OF YOURSELF AND
                  SUCH ORGANIZATION, AND YOU HEREBY REPRESENT AND WARRANT TO US
                  THAT YOU HAVE THE LEGAL AUTHORITY TO BIND SUCH ORGANIZATION TO
                  THIS AGREEMENT. IF YOU DO NOT HAVE THE LEGAL AUTHORITY TO BIND
                  SUCH ORGANIZATION TO THIS AGREEMENT, YOU HEREBY INDEMNIFY AND
                  RELEASE OSHI FROM ANY AND ALL LIABILITY ARISING FROM YOUR USE
                  OF OSHI PLATFORMS.
                </p>
                <br />
                <p>
                  THIS AGREEMENT CONTAINS A{" "}
                  <strong>MANDATORY ARBITRATION PROVISION</strong>
                  THAT, AS FURTHER SET FORTH IN SECTION 18 BELOW, REQUIRES THE
                  USE OF ARBITRATION ON AN INDIVIDUAL BASIS TO RESOLVE DISPUTES,
                  RATHER THAN JURY TRIALS OR ANY OTHER COURT PROCEEDINGS, OR
                  CLASS ACTIONS OF ANY KIND.
                </p>
                <br />
                <p>
                  IF YOU DO NOT AGREE TO THIS AGREEMENT, IMMEDIATELY STOP USING
                  ALL OSHI PLATFORMS AND DO NOT USE ANY SERVICE OR PURCHASE OR
                  RECEIVE ANY PRODUCT, GOOD, OR SERVICE OFFERED THROUGH THE OSHI
                  PLATFORMS.
                </p>
                <br />
                <p>
                  PLEASE REVIEW THE FOLLOWING SECTIONS OF THIS AGREEMENT
                  CAREFULLY: (A) LIMITATION OF LIABILITY IN SECTION 16, (B)
                  INDEMNIFICATION IN SECTION 14, (C) ARBITRATION CLAUSE IN
                  SECTION 18, AND (D) WARRANTY DISCLAIMER IN SECTION 15 BELOW.
                </p>
                <br />

                <p>
                  <strong>1. Eligible Members</strong>
                </p>
                <br />
                <p>
                  To become a Member, you must be a natural person, at least 18
                  years old and provide a verifiable email address and password
                  in order for Oshi to create your Oshi Platform account
                  (“Account”). Each individual person is limited to one Account.
                </p>
                <br />
                <p>
                  Any and all information collected from you shall be subject to
                  our Privacy Policy, a copy of which is located at:
                  https://www.Oshi.com/privacy-policy and which is hereby
                  incorporated by reference (the “Privacy Policy”).
                </p>
                <br />
                <p>
                  <strong>2. Oshi Rewards</strong>
                </p>
                <br />
                <p>
                  For each Eligible Transaction (as defined in Section 3.1),
                  Oshi may grant you certain Rewards, in accordance with this
                  Agreement.{" "}
                  <strong>
                    Eligibility to receive Rewards and the opportunity to
                    receive Rewards are offered at the sole discretion of Oshi
                    and subject to your compliance with this Agreement and any
                    other applicable agreements. Oshi reserves the right to
                    change, upgrade, or discontinue its Rewards offers and any
                    Oshi Platform or any features related thereto, at any time,
                    with or without notice.
                  </strong>{" "}
                  All rights not expressly granted under this Agreement are
                  reserved by Oshi or its licensors.
                </p>
                <br />
                <p>
                  <strong>3. Earning Rewards</strong>
                </p>
                <br />
                <p>
                  <strong>3.1. Eligible Transactions.</strong>
                  <br />
                  Oshi may make available, on the Oshi Platforms, vouchers,
                  promotions, coupons, discounts, or other related offers
                  (collectively, “Merchant Listings”) for services, goods, or
                  products provided by third parties (“Merchants”) to
                  individuals seeking such Merchant Listings (“Purchasers”), as
                  well as references and links to Merchant Listings. The
                  Merchants and Purchasers may be referred to individually as a
                  “User” and collectively herein as “Users.” In order to qualify
                  for Rewards, you must (i) have an Account; and (ii) one of the
                  following events must occur in accordance with applicable
                  terms and conditions (each, an “Eligible Transaction”): (a)
                  you complete a purchase of a Merchant Listing providing for
                  Rewards via an Oshi Platform; (b) a User whom you successfully
                  referred to an Oshi Platform via a QR code, link, or other
                  Oshi-enabled mechanism completes a purchase a Merchant
                  Listing; or (c) a User whom you successfully referred to an
                  Oshi Platform via a QR code, link, or other Oshi-enabled
                  mechanism completes a sale of a Merchant Listing.
                </p>
                <br />
                <p>
                  <strong>3.2 Rewards Adjustments.</strong>
                  <br />
                  The Rewards are subject to adjustment (as further detailed in
                  Section 7 below) in the result of returns, refunds,
                  chargebacks, and/or other determinations that the Rewards do
                  not comply with these Terms. All Rewards are deemed pending
                  for a period of thirty days after the Eligible Transaction and
                  cannot be accessed until after the pending period. Rewards are
                  not guaranteed. Oshi may change the criteria for Eligible
                  Transactions at any time and may, but is not obligated to,
                  notify you of those changes via notifications on Oshi
                  Platforms, email, text, and/or updates to this Agreement.
                </p>
                <br />
                <p>
                  <strong>3.3. Valid Account to Withdraw.</strong>
                  <br />
                  In order to withdraw Rewards, you must have a registered
                  Account with a valid and verified email address and password.
                  Anonymous accounts may be eligible to earn Rewards, but
                  anonymous accounts cannot withdraw Rewards until it is linked
                  with a valid and verified email account.
                </p>
                <br />
                <p>
                  <strong>3.4. Rewards Unsecured.</strong>
                  <br />
                  The Account is not a financial account and does not carry a
                  balance in US dollars (“USD”), bitcoin, or in any other fiat
                  or cryptocurrency on your behalf; it merely (1) records a
                  general unsecured commercial obligation (the “Rewards”) to you
                  by Oshi, as described herein, and (2) allows Oshi to
                  coordinate your participation in the program. “Earn bitcoin”
                  or “earning bitcoin”, “earning sats” or "earning rewards” and
                  other similar terms used herein and in connection with the
                  Oshi Platforms means the right to be paid accrued Rewards
                  added to your Account by Oshi, subject to this Agreement,
                  whether in USD or bitcoin terms, as currency (e.g. bitcoin,
                  USD, etc.) payouts, voucher payouts, etc., as determined
                  within Oshi’s sole discretion. It does not mean that the
                  Rewards, or any funds whatever, are held on your behalf.
                  Further, by agreeing to these terms, you represent that you
                  understand that you do not have right, legal title, or a
                  security interest in any particular assets of Oshi, and you
                  understand and agree that the only remedies available to you
                  for controversies arising from this Agreement or your use of
                  Oshi Platforms generally are subject to this Agreement (e.g.
                  Section 18).
                </p>
                <br />
                <p>
                  <strong>3.5 Calculating Rewards.</strong>
                  <br />
                  Each Eligible Transaction shall occur on an applicable
                  transaction date, and Oshi shall calculate your eligible
                  Reward amount on a per-Eligible Transaction basis using (i)
                  the Bitcoin value on the applicable transaction date, and (ii)
                  the applicable amount or percentage of the amount of your
                  Eligible Transaction, which may or may not be communicated to
                  you prior to the Eligible Transaction, and which may further
                  vary from time to time or Eligible Transaction to Eligible
                  Transaction, at Oshi’s sole discretion. Oshi calculates the
                  Bitcoin value using the exchange rates provided by certain
                  data feeds, as determined by Oshi in its sole discretion. All
                  calculations and determinations, including the determination
                  of Bitcoin value on any given transaction date and whether any
                  particular transaction meets the requirements for a Eligible
                  Transaction, shall be performed by Oshi at its sole
                  discretion. You agree to release Oshi from, and Oshi hereby
                  disclaims, any and all liability in connection with (a)
                  incorrect information obtained from third-parties regarding
                  the value of Bitcoin on any given date, or (b) any disputes
                  over the value of Bitcoin on any given date.
                </p>
                <br />
                <p>
                  <strong>3.6 No Consideration for Rewards.</strong>
                  <br />
                  You hereby acknowledge and agree that any Rewards granted to
                  you by Oshi in connection with an Eligible Transaction are
                  given without consideration or payment of any kind from you.
                  Oshi may make reasonable adjustments to any reward amounts,
                  including adjustments to the balance in your Account, at any
                  time without advance notice if in its reasonable judgment Oshi
                  finds such adjustments are necessary.
                </p>
                <br />
                <p>
                  <strong>3.7 Limitations.</strong>
                  <br />
                  Your Account may not have an excess of ten thousand dollars
                  ($10,000) of value (the “Account Limit”) or more on any day.
                  The Account Limit includes Rewards marked pending and final.
                  You will not receive Rewards for a Eligible Transaction if
                  such Rewards would cause either (i) your Account balance to
                  exceed the Account Limit, based on our calculation of the
                  value of Bitcoin on that day, or (ii) the total of all your
                  redemptions (as described in Section 8 below) executed that
                  day plus your Account balance to exceed the Account Limit. The
                  Account Limit shall not apply to any individual Eligible
                  Transaction that itself exceeds the Account Limit. For
                  example, if you win one bitcoin in an Eligible Transaction,
                  and that bitcoin’s value is greater than $10,000, that bitcoin
                  shall not apply towards your Account Limit. Additionally, you
                  may not transfer any Rewards in your Account to other Members,
                  or cause Rewards for a Eligible Transaction to be credited to
                  another Member. Your Account, including any Rewards contained
                  in it, may not be assigned or granted to, or inherited by, any
                  other person or party.
                </p>
                <br />
                <p>
                  <strong>4. Exclusions</strong>
                </p>
                <br />
                <p>
                  Rewards are granted by Oshi exclude taxes, fees, discounts or
                  credits, returns or cancellations, and chargebacks. Rewards
                  may not be purchased. Oshi uses reasonable efforts to maintain
                  a list of exclusions. The list of exclusions is subject to
                  change without notice, and Oshi hereby disclaims any and all
                  liability in connection with any incorrect information or
                  failure to include information on the list of exclusions. If
                  you receive Rewards and we later discover that you did not
                  have an Eligible Transaction for those Rewards or that you
                  manufactured spend through your own use or by permitting
                  others to transact on your Account, you may forfeit future
                  Rewards earnings, or we may apply future Rewards or any
                  Rewards not yet redeemed until enough Rewards are accrued to
                  cover it. The Rewards are designed for consumer spend only and
                  may not be manipulated or converted into a commercial spend or
                  financial transaction instrument. In addition, if you make a
                  purchase and your Account is credited with Rewards, any later
                  return, reversal, cancellation or dispute involving any part
                  of the Eligible Transaction will result in your Rewards
                  balance being reversed, debited or cancelled (in whole or
                  part) to reflect that portion of the purchase which has been
                  returned, reversed, cancelled or disputed and may cause your
                  Rewards balance to go negative. We may also take any other
                  action we deem appropriate.
                </p>
                <br />
                <p>
                  <strong>5. Limited License</strong>
                </p>
                <br />
                <p>
                  Subject to this Agreement, we hereby grant you a
                  non-exclusive, non-transferable license (without the right to
                  sublicense) to access and use the Oshi Platforms for your
                  personal use that may lead to Rewards. You agree that you
                  obtain no rights other than the rights and licenses expressly
                  granted in this Agreement.
                </p>
                <br />
                <p>
                  <strong>6. Restrictions on Usage</strong>
                </p>
                <br />
                <p>
                  You agree that you will not, and will not permit others to:
                  (i) damage, interfere with or unreasonably overload the Oshi
                  Platforms; (ii) introduce into the Oshi Platforms any code
                  intended to disrupt the Platform or Rewards; (iii) alter or
                  delete any information, data, text, links, images, software,
                  chat, communications and other content available through the
                  Oshi Platforms (collectively, “Content”); (iv) access the Oshi
                  Platforms by expert system, electronic agent, “bot” or other
                  automated means; (v) use scripts or disguised redirects to
                  derive financial benefit from Oshi; (vi) modify, reverse
                  engineer, reverse assemble, decompile, copy or otherwise
                  derive the source code of any Oshi Platform for any reason;
                  (vii) rent, sell, or sublicense any of the Oshi Platforms;
                  (viii) provide any unauthorized third party with access to the
                  Platform(s); (ix) access confidential Content through the Oshi
                  Platforms; (x) interfere with the operation of the Platform(s)
                  and/or provision of Rewards, including, but not limited to,
                  distribution of unsolicited advertising or mail messages and
                  propagation of computer worms and viruses; (xi) post any
                  material in any form whatsoever on the Oshi Platforms that is
                  defamatory, obscene, or otherwise unlawful or violates any
                  third party’s right of privacy or publicity; (xii) infringe
                  any third party’s patent, copyright, service mark, trademark
                  or other intellectual property right of any kind or
                  misappropriate the trade secrets of any third party in
                  connection with your use of the Oshi Platform(s); (xiii)
                  engage in any activity that does not comply applicable law and
                  regulations or otherwise engage in any illegal, manipulative
                  or misleading activity through the use of the Program.
                </p>
                <br />
                <p>
                  <strong>7. Account Maintenance and Updates</strong>
                </p>
                <br />
                <p>
                  <strong>7.1 Account Adjustments.</strong>
                  <br />
                  In our sole discretion, we may deduct reward credits from your
                  Account in order to make adjustments for returns and
                  cancellations with respect to Eligible Transactions. Any such
                  adjustments, however, will be made in accordance with this
                  Agreement, any applicable Oshi policies and terms, and any and
                  all applicable laws, rules, and regulations. It is your
                  responsibility to check your Account regularly to ensure that
                  Rewards have been properly credited and redeemed and that your
                  Account balance is accurate. If you believe that Rewards have
                  not been correctly credited to your Account, you must contact
                  Oshi Support within thirty (30) days of the Eligible
                  Transaction.{" "}
                  <strong>
                    Should you disagree with any adjustments made to your
                    Account or payments made to you, your sole remedy is to
                    cease using the Oshi Platforms.
                  </strong>
                </p>
                <br />
                <p>
                  <strong>7.2 Misapplied Rewards.</strong>
                  <br />
                  In the event we determine, in our sole discretion, that you
                  have been credited rewards which were misapplied by us for any
                  reason, we may deduct the misapplied rewards from your
                  Account. If you have redeemed the misapplied rewards, you
                  agree to promptly return to us the balance of the misapplied
                  rewards, less $100, which you may keep. If you refuse to
                  promptly return the misapplied redeemed rewards, you agree to
                  reimburse us for all costs and reasonable attorneys’ fees
                  associated with our recovery of the misapplied redeemed
                  rewards.
                </p>
                <br />
                <p>
                  <strong>7.3 Taxes.</strong>
                  <br />
                  You may be taxed on your receipt of Rewards depending on the
                  tax laws of federal, state, and local jurisdictions. You will
                  be solely responsible for any and all tax liability arising
                  out of the consideration received in connection with the
                  Program.{" "}
                  <strong>
                    We may need to collect certain identifying information from
                    you in order to fulfill our tax reporting obligations, and
                    in the event you are unable or unwilling to provide such
                    information, you may forfeit your Rewards.
                  </strong>
                </p>
                <br />
                <p>
                  <strong>7.4 Updating Your Account.</strong>
                  <br />
                  You agree to keep your Account information current, complete,
                  and accurate by periodically updating the information through
                  the Oshi Platforms. You must be logged into Oshi and enter
                  your password to change your Account information. You may
                  check your Account status and recent Rewards history at any
                  time via the Oshi Platforms. You will maintain the
                  confidentiality of your Account information, including
                  username and password by which you access the Oshi Platforms.
                  Any use of your username or password will be deemed to be your
                  use, and Oshi is entitled to act on instructions received
                  under your password and is not responsible for any changes
                  made to your Account or redemption of Rewards made by someone
                  else who uses your password. If there is a breach of security
                  through your Account, you will immediately change your
                  password and notify us of such breach. You agree that, unless
                  you have first notified us immediately of any such breach, we
                  should assume that any instruction transmitted using your
                  username and password is yours and has been authorized by you,
                  and we will have no further obligation to investigate the
                  propriety of such instruction.
                </p>
                <br />
                <p>
                  <strong>7.5 Maintaining Your Active Account.</strong>
                  <br />
                  An Active Account means you must have completed a purchase on
                  a Oshi Platform in the last twelve (12) calendar months. If
                  your Account becomes inactive, Oshi may also elect, at its
                  sole discretion, to close your Account permanently and cease
                  to maintain your Account records and Oshi Platform access. You
                  hereby acknowledge and agree that by failing to maintain an
                  Active Account you abandon any claim and forfeit all rights to
                  the Rewards in your Account at that time and any associated
                  gains or losses. Oshi shall not be liable to you for the value
                  of any Rewards, or any gains or losses associated with the
                  value of the Rewards in your Account, at the time your Account
                  is closed for inactivity in accordance with this Section.
                </p>
                <br />
                <p>
                  <strong>7.6 Fraudulent Activity.</strong>
                  <br />
                  We reserve the right to investigate any purchase transactions,
                  referral activity, or interaction with any Oshi Platform that
                  we believe, in our sole discretion, is abusing or has abused
                  Oshi or any Oshi Platform. We reserve the right to rescind any
                  Rewards accrued by, bar further Rewards to, and/or terminate
                  the membership of, any Member that we believe, in our sole
                  discretion, is abusing or has abused Oshi or any Oshi
                  Platform, including, but not limited to, by engaging in a
                  pattern of returning products after the corresponding Bitcoin
                  has been credited, or making fraudulent referrals and/or
                  Eligible Transactions by creating multiple Accounts. Any
                  failure to comply with this Agreement, any fraud or abuse
                  relating to the accrual or receipt of Rewards, or any
                  misrepresentation of any information furnished to Oshi by you
                  or anyone acting on your behalf will result in the termination
                  of your membership and forfeiture of your accrued Rewards. If
                  Oshi has any reason to suspect fraudulent activity is
                  associated with your Account, Oshi reserves the right to delay
                  or withhold redemption of Rewards. Any suspected or actual
                  cases of fraud activity will be escalated and reviewed at
                  Oshi’s sole discretion and may result in civil or criminal
                  penalties.
                </p>
                <br />
                <p>
                  <strong>8. Assumption of Risk</strong>
                </p>
                <br />
                <p>
                  <strong>8.1. Bitcoin Value.</strong> <br />
                  BITCOIN VALUES CAN FLUCTUATE SUBSTANTIALLY WHICH MAY RESULT IN
                  A TOTAL LOSS OF THE VALUE OF YOUR REWARDS. OSHI DOES NOT OWN
                  OR CONTROL ANY OF THE SOFTWARE PROTOCOLS THAT ARE USED IN
                  CONNECTION WITH THE BITCOIN VALUATION. ACCORDINGLY, OSHI
                  DISCLAIMS ALL LIABILITY RELATING TO ANY VALUATION FLUCTUATIONS
                  IN THE REWARDS, AND MAKES NO GUARANTEES REGARDING THE
                  SECURITY, FUNCTIONALITY, OR AVAILABILITY OF SUCH PROTOCOLS.
                </p>
                <br />
                <p>
                  <strong>8.2 Protocol Forks.</strong>
                  <br />
                  BY USING THE OSHI PLATFORMS, YOU ACKNOWLEDGE AND AGREE THAT
                  THE UNDERLYING PROTOCOLS ARE SUBJECT TO SUDDEN CHANGES IN
                  OPERATING RULES (KNOWN AS “FORKS”), AND THAT SUCH FORKS MAY
                  MATERIALLY AFFECT THE VALUE, FUNCTION, AND/OR EVEN THE NAME OF
                  THE BITCOIN TO WHICH THE REWARDS ARE PEGGED. IN THE EVENT OF A
                  FORK, YOU AGREE THAT WE MAY TEMPORARILY SUSPEND OPERATIONS
                  (WITH OR WITHOUT ADVANCE NOTICE TO YOU) AND THAT WE MAY, IN
                  OUR SOLE DISCRETION, DECIDE WHETHER OR NOT TO ADJUST YOUR
                  REWARD BALANCE AS A RESULT OF THE FORKED PROTOCOL.
                </p>
                <br />
                <p>
                  <strong>8.3 Risk of System Failure.</strong>
                  <br />
                  YOU ACCEPT ALL RISKS ASSOCIATED WITH THE USE OF THE REWARDS
                  BEING ASSOCIATED WITH BITCOIN, AND ANY FAILURES THAT MIGHT
                  ARISE AS A RESULT THEREOF, INCLUDING, BUT NOT LIMITED TO, IN
                  CONNECTION WITH THE FAILURE OF HARDWARE, SOFTWARE, AND
                  INTERNET CONNECTIONS. THE NATURE OF BITCOIN MEANS THAT ANY
                  TECHNOLOGICAL DIFFICULTIES EXPERIENCED BY OSHI MAY PREVENT
                  OSHI FROM BEING ABLE TO SUCCESSFULLY REDEEM YOUR REWARDS FOR
                  BITCOIN.
                </p>
                <br />
                <p>
                  <strong>8.4 Market Disruption.</strong>
                  <br />
                  You agree that we are not liable for any price fluctuations in
                  Bitcoin. In the event of a market disruption, we may do one or
                  more of the following: (a) suspend Rewards earning or
                  redemptions; or (b) prevent you from completing any actions
                  via the Oshi Platforms. We will not be liable for any losses
                  suffered by you resulting from such actions. Following any
                  such event, when the Oshi Platforms resume, you acknowledge
                  that prevailing market rates may differ significantly from the
                  rates available prior to such event.
                </p>
                <br />
                <p>
                  <strong>8.5 No Liability for Unauthorized Access.</strong>
                  <br />
                  Our responsibility is limited to the exercise of ordinary
                  diligence in giving access to redeemed Rewards upon request
                  and in preventing access to your Rewards by unauthorized
                  persons. We are not responsible for any unauthorized access or
                  loss or harm an unauthorized access cause, unless caused only
                  by our gross negligence or our willful misconduct.
                </p>
                <br />
                <p>
                  <strong>8.6 Risks Inherent to Bitcoin.</strong>
                  <br />
                  (a) Bitcoin transactions are irreversible, and, accordingly
                  losses due to fraudulent or accidental transactions may not be
                  recoverable and Oshi shall not be held liable for any
                  fraudulent or accidental transactions; (b) Bitcoin is not
                  legal tender and is not backed by a government or central bank
                  and Oshi is not a bank. As such, there is no protection, such
                  as deposit insurance, to cover any losses associated with
                  Bitcoin; (c) legislative and regulatory changes or actions at
                  the state, federal or international level may adversely affect
                  the use, transfer, exchange, and value of Bitcoin—the Bitcoin
                  public ledger blockchain is maintained by a vast unidentified
                  private computer network spread around the world and choosing
                  to participate in Bitcoin is at your own risk and
                  understanding of this network; (d) Bitcoin is a target for
                  fraud and the potential for fraud is especially likely when
                  you engage in transactions with external Bitcoin addresses;
                  (e) Bitcoin is a target for hackers and hacking can occur even
                  when you use the strongest security settings and as such your
                  Bitcoin may be irretrievably stolen; (f) your bank accounts
                  are at increased risk of being hacked when linked to Bitcoin
                  accounts; (g) some Bitcoin transactions shall be deemed to be
                  made when recorded on a public ledger, which is not
                  necessarily the date or time that you have initiated the
                  transaction; (h) the value of Bitcoin may be derived from the
                  continued willingness of market participants to exchange fiat
                  currency for Bitcoin, which may result in the potential for
                  permanent and total loss of value of a particular Bitcoin
                  should the market for that Bitcoin disappear; (i) there is no
                  assurance that a person who accepts Bitcoin as payment today
                  will continue to do so in the future; (j) the volatility and
                  unpredictability of the price of Bitcoin relative to fiat
                  currency may result in significant loss over a short period of
                  time; and (k) Oshi is not obligated to hold any bond or trust
                  account to cover any losses incurred by any Members; and (l)
                  in the event that Oshi holds such bond or trust account, any
                  bond or trust account held by Oshi may not be sufficient to
                  cover all losses incurred by our customers.
                </p>
                <br />
                <p>
                  <strong>9. Communications from Oshi</strong>
                </p>
                <br />
                <p>
                  By signing up to be a Member, you agree to receive
                  communications that are account and membership related (e.g.,
                  that you’ve received Rewards) as well as periodic
                  shopping-related emails or app notifications that highlight
                  special deals that are available to Oshi Members. We may
                  communicate with you regarding your membership and/or Oshi
                  Platforms by electronic communications or direct mail using
                  information you provided during the registration process. Your
                  consent to receive electronic communications includes any
                  notices or other information that we may be required by law to
                  provide you in writing or otherwise. You agree to keep us
                  apprised of your current email address should the same change
                  subsequent to the date you become a Member. We may also send
                  you push notifications if you install the mobile application.
                  You may opt out of receiving certain communications in
                  accordance with our Privacy Policy.
                </p>
                <br />
                <p>
                  <strong>10. Exports of Oshi Platforms</strong>
                </p>
                <br />
                <p>
                  Oshi Platforms and their underlying information and technology
                  may not be exported or re-exported into any country to which
                  the U.S. has embargoed goods or to anyone on the U.S. Treasury
                  Department’s list of Specially Designated Nationals or the
                  U.S. Commerce Department’s Table of Deny Orders. You represent
                  and warrant that you are not located in, under the control of,
                  or a national or resident of any such country or on any such
                  list, and that you will otherwise comply with all applicable
                  export control laws. If you are a U.S. government end user, we
                  are licensing the Oshi Platform(s) to you as a “Commercial
                  Item” as that term is defined in the U.S. Code of Federal
                  Regulations (see 48 C.F.R. § 2.101), and the rights we grant
                  you to the Oshi Platform(s) are the same as the rights we
                  grant to all others under this Agreement.
                </p>
                <br />
                <p>
                  <strong>11. Third-Party Platforms</strong>
                </p>
                <br />
                <p>
                  Oshi uses a third-party, OpenNode, Inc. (“OpenNode”), to
                  facilitate Eligible Transactions and the distribution of
                  Rewards. By enrolling in or using any Oshi Platform, you
                  acknowledge that you have read and understand OpenNode’s Terms
                  and Conditions (found at
                  https://www.opennode.com/terms-and-conditions/) and OpenNode’s
                  Privacy Policy (found at
                  https://www.opennode.com/privacy-policy/) and further agree to
                  be bound by all terms found therein.
                </p>
                <br />

                <p>
                  Additionally, when you access or use the Oshi Platforms, we
                  may make available other services from one or more third
                  parties (“Third-Party Platforms”). The Oshi Platforms may
                  support Third Party Platforms, including without limitation
                  Twitter, Facebook and/or Google, to make it easier for you to
                  sign in or create your Oshi Account. Any use of Third Party
                  Platforms to create and access your Oshi Account are subject
                  to the terms and conditions and privacy policies of such third
                  parties (“Third Party Terms”).
                </p>
                <br />
                <p>
                  <strong>12. Acknowledgment of Community Standards</strong>
                </p>
                <br />
                <p>
                  By having an Account with an Oshi Platform, you are becoming a
                  Member of a community that depends on the goodwill and
                  responsible behavior of each of our Members. Members are
                  required to refrain from transmission or communication of
                  images or text constituting ethnic slurs, obscenities,
                  sexually explicit material, inflammatory or derogatory
                  comments, or anything else that may be construed as harassing
                  or offensive, which is targeted at the Oshi Platforms, our
                  employees, contractors or agents, or other Members. This
                  includes communications by means of social media or other
                  Internet posts which violate the above community standards or
                  promote or encourage gaming or fraudulent behavior. Members
                  who violate this provision, as determined by us in our sole
                  discretion, may have their access to the Oshi Platforms
                  suspended or terminated without prior notice. For the
                  avoidance of doubt, any Member whose access is so terminated
                  forfeits all rights to any accrued Rewards in his or her
                  Account
                </p>
                <br />
                <p>
                  <strong>13. Ownership</strong>
                </p>
                <br />
                <p>
                  All right, title, and interest in the Oshi Platforms and the
                  Content belong to Oshi or its licensors. Additionally, Oshi
                  shall maintain all right, title, and interest in “Oshi,” the
                  Oshi logo, and any other marks, service marks, trademarks, or
                  logos of Oshi (“Oshi Marks”), whether or not such marks are
                  registered in the U.S. and/or other countries. The Oshi Marks
                  may not be used in connection with any product or service that
                  is not Oshi in any manner that is likely to cause confusion
                  among customers, or in any manner that disparages or
                  discredits Oshi. You shall not by any means bid on any
                  keywords with any search engine containing “Oshi” or anything
                  substantially similar to “Oshi” or any other Oshi Mark
                  including, but not limited to, Oshi.com, Oshi.tech, or
                  Oshiapp.com. You shall not mention or use Oshi in any ad text,
                  extensions or banner ads without the express written consent
                  of Oshi. All other trademarks not owned by Oshi that are used
                  in the Oshi Platforms are the property of their respective
                  owners, who may or may not be affiliated with, connected to,
                  or sponsored by Oshi.
                </p>
                <br />
                <p>
                  <strong>14. Indemnification</strong>
                </p>
                <br />
                <p>
                  You agree, at your sole expense, to defend, indemnify and hold
                  us, our affiliates, our Merchants, payment processors,
                  financial institutions, our service providers and consultants,
                  and our and their respective directors, employees and agents,
                  harmless from and against any and all actual or threatened
                  suits, actions, proceedings (at law or in equity), claims,
                  damages, payments, deficiencies, fines, judgments,
                  settlements, liabilities, losses, costs and expenses
                  (including, but not limited to, reasonable attorney fees,
                  costs, penalties, interest and disbursements) caused by,
                  arising out of, resulting from, attributable to or in any way
                  incidental to: (i) your use of the Oshi Platforms; (ii) your
                  violation of this Agreement; or (iii) your violation of the
                  rights of any third-party.
                </p>
                <br />
                <p>
                  If you are a California resident, you waive California Civil
                  Code Section 1542, which says: “A general release does not
                  extend to claims which the creditor does not know or suspect
                  to exist in his favor at the time of executing the release,
                  which if known by him must have materially affected his
                  settlement with the debtor.” If you are a resident of another
                  jurisdiction, you waive any comparable statute or doctrine.
                </p>
                <br />
                <p>
                  <strong>15. Warranty Disclaimer</strong>
                </p>
                <br />
                <p>
                  THE CONTENT AND THE OSHI PLATFORMS ARE PROVIDED “AS IS” AND
                  WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING,
                  WITHOUT LIMITATION, WARRANTIES OF TITLE, MERCHANTABILITY,
                  FITNESS FOR A PARTICULAR PURPOSE OR NON-INFRINGEMENT. WE MAKE
                  NO WARRANTY AS TO THE QUALITY, ACCURACY, CURRENTNESS,
                  COMPLETENESS, RELIABILITY OR VALIDITY OF THE CONTENT OR THE
                  OSHI PLATFORMS, INCLUDING, WITHOUT LIMITATION, ANY PRODUCT
                  SEARCH RESULTS, PRODUCT DESCRIPTIONS, PRODUCT AVAILABILITY,
                  PRICING INFORMATION ADVICE, OPINION, STATEMENT,
                  RECOMMENDATIONS, OR OTHER INFORMATION DISPLAYED, UPLOADED, OR
                  DISTRIBUTED IN CONNECTION WITH THE OSHI PLATFORMS. OSHI DOES
                  NOT WARRANT THAT THE FUNCTIONALITY OF THE OSHI PLATFORMS WILL
                  BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE
                  CORRECTED, OR THAT THEY WILL BE FREE OF VIRUSES OR OTHER
                  HARMFUL COMPONENTS. FURTHER, OSHI DOES NOT WARRANT, GUARANTEE
                  OR MAKE ANY REPRESENTATIONS REGARDING THE QUALITY OF, OR
                  ACCURACY OF ADVERTISEMENTS FOR, ANY PRODUCTS OR SERVICES
                  OFFERED OR PROVIDED BY MERCHANTS UTILIZING THE OSHI PLATFORMS.
                </p>
                <br />
                <p>
                  <strong>16. Limitation on Liability</strong>
                </p>
                <br />
                <p>
                  TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW: OSHI
                  WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
                  CONSEQUENTIAL, SPECIAL, EXEMPLARY OR PUNITIVE DAMAGES OF ANY
                  KIND, UNDER ANY CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT
                  LIABILITY OR OTHER THEORY, INCLUDING DAMAGES FOR LOSS OF
                  PROFITS, USE OR DATA, LOSS OF OTHER INTANGIBLES, LOSS OF
                  SECURITY OF INFORMATION TRANSMITTED VIA THE OSHI PLATFORMS
                  (INCLUDING UNAUTHORIZED INTERCEPTION BY THIRD PARTIES OF SUCH
                  INFORMATION), EVEN IF ADVISED IN ADVANCE OF THE POSSIBILITY OF
                  SUCH DAMAGES OR LOSSES. WITHOUT LIMITING THE FOREGOING, TO THE
                  FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW: (A) OSHI WILL
                  NOT BE LIABLE FOR DAMAGES OF ANY KIND RESULTING FROM YOUR USE
                  OF OR INABILITY TO USE THE OSHI PLATFORMS OR FROM ANY PRODUCTS
                  OR THIRD PARTY MATERIALS: (B) YOUR SOLE AND EXCLUSIVE REMEDY
                  FOR DISSATISFACTION WITH THE OSHI PLATFORMS OR ANY PRODUCTS OR
                  THIRD PARTY MATERIALS IS TO STOP USING THE OSHI PLATFORMS: AND
                  (C) THE MAXIMUM AGGREGATE LIABILITY OF OSHI FOR ALL DAMAGES,
                  LOSSES AND CAUSES OF ACTION, WHETHER IN CONTRACT, TORT
                  (INCLUDING NEGLIGENCE) OR OTHERWISE, SHALL BE THE GREATER OF:
                  (1) THE TOTAL AMOUNT, IF ANY, PAID BY YOU TO OSHI TO USE THE
                  OSHI PLATFORMS; AND (2) TEN U.S. DOLLARS ($10).
                </p>
                <br />
                <p>
                  ALL LIMITATIONS OF LIABILITY OF ANY KIND (INCLUDING IN THIS
                  SECTION AND ELSEWHERE IN THIS AGREEMENT) ARE MADE FOR THE
                  BENEFIT OF BOTH OSHI AND THE AFFILIATED ENTITIES.
                </p>
                <br />
                <p>
                  Applicable law in certain states may not allow for limitations
                  on certain implied warranties, or exclusions or limitations of
                  certain damages; solely to the extent that such law applies to
                  you, some or all of the above disclaimers, exclusions, or
                  limitations may not apply to you, and you may have certain
                  additional rights.
                </p>
                <br />
                <p>
                  <strong>17. Termination or Suspension</strong>
                </p>
                <br />
                <p>
                  This Agreement is effective when immediately upon your
                  creation of an Account on an Oshi Platform and will remain in
                  effect until you or we terminate your membership with Oshi or
                  an Oshi Platform. We may terminate this Agreement and your use
                  of or access to the Oshi Platforms at any time, for any reason
                  or no reason. Any violation of this Agreement or the rules and
                  conditions of the Oshi Platforms (including, but not limited
                  to, the Oshi Terms of Service and/or Oshi Privacy Policy) may
                  result in cancellation of your membership to Oshi Platforms,
                  your Account and/or forfeiture of pending or prior Rewards. We
                  may, in our sole discretion, at any time and without prior
                  notice, discontinue, cancel, suspend, change or limit access
                  to all or any part, functionality, feature, or other component
                  of any Oshi Platform. You agree that Oshi will not be liable
                  to you or to any third party for any modification, suspension,
                  or termination of Oshi’s provision of Rewards to you or your
                  access to any of the Oshi Platforms. If you are dissatisfied
                  with any aspect of the Oshi Platforms at any time, your sole
                  and exclusive remedy is to cease participating in the Oshi
                  Platforms. Termination will not prejudice either your or our
                  remedies at law or in equity.
                </p>
                <br />
                <p>
                  <strong>18. Dispute Resolution & Arbitration</strong>
                </p>
                <br />
                <p>
                  If a dispute, controversy or claim, of any kind and every kind
                  or type, whether based on contract, tort, statute,
                  regulations, or otherwise, arising out of, or connected with,
                  or relating in any way to this Agreement, or the relationship
                  of the parties, or the obligations of the parties, or the
                  scope of this arbitration agreement, of the operations carried
                  out under this Agreement, including without limitation, any
                  dispute as to the existence, validity, construction,
                  interpretation, negotiation, performance, non-performance,
                  breach, termination, scope, or enforceability of this
                  Agreement, or the breach thereof (any one of which
                  constituting the “Dispute”), and if the Dispute cannot be
                  settled through direct discussions (in the opinion of any
                  party), the parties agree to first endeavor to settle the
                  Dispute in an amicable manner by mediation under the then
                  current Commercial Mediation Rules of the American Arbitration
                  Association (“AAA”), before resorting to arbitration. If the
                  Dispute is not settled by mediation within thirty (30) days of
                  written request for mediation by any party to AAA, then and
                  thereafter any unresolved Dispute, including the arbitrability
                  of any unresolved Dispute, shall be settled by arbitration
                  administered by the American Arbitration Association (“AAA”)
                  in accordance with the then current AAA Commercial Arbitration
                  Rules with the award being final and binding. Judgment upon
                  the award rendered by the arbitrator may be entered in any
                  court having jurisdiction thereof. Any provisional remedy
                  which would be available from a court of law shall be
                  available from the arbitrator to the parties to this Agreement
                  pending arbitration.
                </p>
                <br />
                <p>
                  The Federal Arbitration Act shall govern all arbitration
                  proceedings under this Agreement. This Agreement shall in all
                  other respects be governed and interpreted by the laws of the
                  State of Texas, including its statutes of limitation but
                  excluding any conflicts or choice of law rule or principles
                  that might otherwise refer construction or interpretation of
                  this Agreement to the substantive law of another jurisdiction.
                  The arbitration shall be conducted in Fort Worth, Texas, by
                  one neutral arbitrator chosen by AAA according to its
                  Commercial Arbitration Rules. Neither party nor the arbitrator
                  may disclose the existence, content, or results of any
                  arbitration hereunder without the prior written consent of all
                  parties. All fees and expenses of the arbitration shall be
                  borne by the parties equally who shall make deposits as
                  requested by AAA of each party’s share of the deposits
                  requested. Failure or refusal by a party to pay its share of
                  the requested deposits shall constitute a waiver by the
                  non-paying party of its rights to be heard, present evidence,
                  cross-examine witnesses, and assert counterclaims in the
                  arbitration. Informing the arbitrator of a party’s failure to
                  pay its share of the requested deposits for the purpose of
                  implementing this waiver provision shall not be deemed to
                  affect the arbitrator’s impartiality, neutrality,
                  independence, or ability to proceed with the arbitration.
                  However, each party shall bear the expense of its own counsel,
                  experts, witnesses, and preparation and presentation of
                  proofs. The prevailing party, according to the arbitrator,
                  shall be entitled to an award of reasonable attorney’s fees
                  for the arbitration and for all appeals of the award,
                  arbitration fees and administrative expenses, and pre-award
                  and post-award interest at the prevailing Texas statutory
                  pre-judgment and post-judgment interest rates. This agreement
                  to arbitrate shall survive the termination or repudiation of
                  this Agreement.
                </p>
                <br />
                <p>
                  <strong>19. Assignment</strong>
                </p>
                <br />
                <p>
                  Oshi may assign this Agreement and its rights or delegate its
                  obligations under without your consent. You may not assign
                  your rights and obligations under this Agreement, in whole or
                  in part, without our prior written consent, and any such
                  assignment without such consent will be null and void.
                </p>
                <br />
                <p>
                  <strong>20. Severability</strong>
                </p>
                <br />
                <p>
                  If any provision of this Agreement shall be deemed unlawful,
                  void or for any reason unenforceable, then that provision
                  shall be deemed severable from this Agreement and shall not
                  affect the validity and enforceability of any remaining
                  provisions.
                </p>
                <br />
                <p>
                  <strong>21. No Waiver</strong>
                </p>
                <br />
                <p>
                  Enforcement of this Agreement is solely in our discretion and
                  our failure to enforce a provision in some instances does not
                  constitute a waiver of our right to enforce such provision in
                  other instances.
                </p>
                <br />
                <p>
                  <strong>22. Entire Agreement; Conflicts</strong>
                </p>
                <br />
                <p>
                  This Agreement represents the entire agreement of the parties
                  with respect to the subject matter hereof, and supersedes all
                  prior or contemporaneous agreements or representations,
                  written or oral (including without limitation, earlier
                  versions of this Agreement that may have been accepted by
                  you). We reserve the right to modify this Agreement at any
                  time. Your non-termination and continued participation in the
                  or use of any Oshi Platform after modification of this
                  Agreement will constitute affirmative acceptance by you of
                  such modification and your consent to abide by any terms
                  thereof. In the event of a conflict between the terms of this
                  Agreement and the terms of another agreement between you and
                  Oshi, the terms of this Agreement shall govern unless
                  otherwise specified herein or therein.
                </p>
                <br />
                <p>
                  <strong>23. No Reliance</strong>
                </p>
                <br />
                <p>
                  You acknowledge that you have read this Agreement, and that in
                  entering into it, you are not acting or relying on any
                  representations, warranties, agreements, or inducements other
                  than those expressly made herein. It is agreed and
                  acknowledged that you are acting fully and freely upon your
                  own investigation and knowledge and that you voluntarily bind
                  yourself by this Agreement of your own free will. In creating
                  an Account and accepting this Agreement, you further
                  acknowledge that you have had the opportunity to rely upon the
                  advice of counsel of your own selection. Because you
                  extensively reviewed this Agreement prior to your acceptance
                  of it, this Agreement shall be interpreted without regard to
                  the party who drafted the Agreement.
                </p>
                <br />
                <p>
                  <strong>24. Contact Us</strong>
                </p>
                <br />
                <p>
                  If you have a question or complaint regarding Rewards or the
                  Oshi Platforms, please contact us by visiting
                  https://www.oshi.tech
                </p>
                <br />
                <p>
                  You may also email us at: <br />
                  <strong>satoshi@Oshi.tech</strong>
                </p>

                <br />
                <p>
                  You may also contact us by writing to: <br />
                  <strong>
                    Oshi <br />
                    Attn: Customer Service <br />
                    245 Lazy Creek Dr
                    <br />
                    Georgetown, TX 78628 <br />
                  </strong>
                </p>
                <br />
                <p>
                  You may contact us by phone by calling: <br />
                  <strong>1-617-682-9767</strong> <br />
                </p>
                <br />
                <p>
                  Please note that email communications will not necessarily be
                  secure; accordingly, you should not include credit card
                  information or other sensitive information in your email
                  correspondence with us. California residents may reach the
                  Complaint Assistance Unit of the Division of Consumer Services
                  of the California Department of Consumer Affairs by mail at
                  1625 North Market Blvd., Sacramento, CA 95834, or by telephone
                  at (916) 445-1254 or (800) 952-5210.
                </p>

                <br />
              </IonCardContent>
            </>
          )}
        </IonCard>
      </IonContent>
    </div>
  );
};

export default Terms;
